export default "__VITE_ASSET__DWLjsPxD__"